
/**
 * Custom Cart Drawer dynamic updates patch
 */
document.addEventListener('DOMContentLoaded', () => {
  const patchCartDrawer = () => {
    const CartDrawerForm = customElements.get('sht-cart-drwr-frm');
    if (CartDrawerForm) {
      // Patch getSectionsToRender
      if (CartDrawerForm.prototype.getSectionsToRender) {
        const originalGetSections = CartDrawerForm.prototype.getSectionsToRender;
        CartDrawerForm.prototype.getSectionsToRender = function() {
          const sections = originalGetSections.apply(this, arguments);
          sections.forEach(s => {
            if (s.id === 'cartDrawer' && !s.selectors.includes('.js-cart-visuals-top')) {
              s.selectors.push('.js-cart-visuals-top');
            }
          });
          return sections;
        };
      }
      
      // Patch getSectionsToRenderDiscount
      if (CartDrawerForm.prototype.getSectionsToRenderDiscount) {
        const originalGetSectionsDiscount = CartDrawerForm.prototype.getSectionsToRenderDiscount;
        CartDrawerForm.prototype.getSectionsToRenderDiscount = function() {
          const sections = originalGetSectionsDiscount.apply(this, arguments);
          sections.forEach(s => {
            if (s.id === 'cartDrawer' && !s.selectors.includes('.js-cart-visuals-top')) {
              s.selectors.push('.js-cart-visuals-top');
            }
          });
          return sections;
        };
      }
      console.log('Cart Drawer visuals-top patch applied to all render methods');
    }
    // Modal Handling with Delegation
    document.addEventListener('click', (e) => {
      const openDiscountBtn = e.target.closest('.js-open-discount-modal');
      const openNotesBtn = e.target.closest('.js-open-notes-modal');
      const closeBtn = e.target.closest('.js-close-cart-modal');
      const overlay = document.querySelector('.js-cart-modal-overlay');

      if (openDiscountBtn) {
        const modal = document.querySelector('.js-discount-modal');
        overlay?.classList.add('is-active');
        modal?.classList.add('is-active');
      }

      if (openNotesBtn) {
        const modal = document.querySelector('.js-notes-modal');
        overlay?.classList.add('is-active');
        modal?.classList.add('is-active');
      }

      if (closeBtn || (e.target === overlay)) {
        closeModals();
      }
    });

    const closeModals = () => {
      const overlay = document.querySelector('.js-cart-modal-overlay');
      overlay?.classList.remove('is-active');
      document.querySelectorAll('.cart-drawer__modal').forEach(m => m.classList.remove('is-active'));
    };

    // Discount Application
    document.querySelector('.js-apply-discount-btn')?.addEventListener('click', async () => {
      const code = document.querySelector('#cartDiscountInput')?.value;
      if (!code) return;

      const btn = document.querySelector('.js-apply-discount-btn');
      const msg = document.querySelector('.js-discount-message');
      btn.innerText = 'Applying...';

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'discount_code': code } })
        });
        
        msg.innerText = 'Discount added! It will be applied at checkout.';
        msg.classList.remove('d-none');
        msg.style.color = '#8f9e71';
        
        const openBtn = document.querySelector('.js-open-discount-modal');
        openBtn.classList.add('is-active');
        openBtn.querySelector('span').innerText = code;
        
        setTimeout(() => {
          btn.innerText = 'Apply';
          closeModals();
          
          // Add hidden input to form if not exists
          const form = document.querySelector('#cart-drawer-form');
          if (form) {
            let input = form.querySelector('input[name="discount"]');
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'discount';
              form.appendChild(input);
            }
            input.value = code;
          }
        }, 1500);
      } catch (err) {
        btn.innerText = 'Apply';
        msg.innerText = 'Error applying discount.';
        msg.classList.remove('d-none');
        msg.style.color = 'red';
      }
    });

    // Copy Coupon
    document.querySelectorAll('.js-copy-coupon').forEach(btn => {
      btn.addEventListener('click', () => {
        const code = btn.dataset.code;
        navigator.clipboard.writeText(code).then(() => {
          const originalText = btn.innerText;
          btn.innerText = 'Copied!';
          btn.classList.add('copied');
          document.querySelector('#cartDiscountInput').value = code;
          setTimeout(() => {
            btn.innerText = originalText;
            btn.classList.remove('copied');
          }, 2000);
        });
      });
    });

    // Save Note
    document.querySelector('.js-save-note-btn')?.addEventListener('click', async () => {
      const note = document.querySelector('#cartModalNoteInput')?.value;
      const btn = document.querySelector('.js-save-note-btn');
      btn.innerText = 'Saving...';

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note })
        });
        
        const openBtn = document.querySelector('.js-open-notes-modal');
        if (note.trim() !== '') {
          openBtn.classList.add('is-active');
          openBtn.querySelector('span').innerText = 'Edit Note';
        } else {
          openBtn.classList.remove('is-active');
          openBtn.querySelector('span').innerText = 'Order Note';
        }
        
        setTimeout(() => {
          btn.innerText = 'Save Note';
          closeModals();
        }, 500);
      } catch (err) {
        btn.innerText = 'Error Saving';
      }
    });
  };

  // If already defined, patch now, otherwise wait for it
  if (customElements.get('sht-cart-drwr-frm')) {
    patchCartDrawer();
  } else {
    const observer = new MutationObserver((mutations) => {
      if (customElements.get('sht-cart-drwr-frm')) {
        patchCartDrawer();
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
});

/**
 * Footer Toggles for Discount and Notes
 */
// Re-initialize after cart updates
document.addEventListener('cart:update', () => {
  // Logic to handle any re-binding if needed (not needed for delegated click)
});
